/**
 * Matching for the Switch Facility search box.
 *
 * The list shows a "Corporate" label under corporate entries, so people type
 * "corporate" to find them. Before this, only the facility name and ID were
 * searched, and a corporate entry whose name doesn't say "corporate" (e.g.
 * "Hospitality Consulting & Supply") could not be found that way (#2078).
 *
 * Every word typed must match something: the name, the ID, or the start of the
 * "Corporate" label. Word order doesn't matter, so "corp hosp" finds
 * "Hospitality Consulting & Supply".
 */
export interface SearchableFacility {
  name: string;
  organizationId: string;
  isCorporate?: boolean;
}

export const CORPORATE_LABEL = 'corporate';

export function facilityMatchesSearch(facility: SearchableFacility, search: string): boolean {
  const terms = search.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (terms.length === 0) return true;
  const name = facility.name.toLowerCase();
  return terms.every(
    (t) =>
      name.includes(t) ||
      facility.organizationId.includes(t) ||
      (!!facility.isCorporate && CORPORATE_LABEL.startsWith(t)),
  );
}
